export default __webpack_public_path__ + "static/media/studio-select-icon.9c39cc3d.svg";